class ProductDetailsReadMore extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #button = null;

  /** @type {HTMLElement | null} */
  #columns = null;

  connectedCallback() {
    this.#button = this.querySelector('[data-read-more-toggle]');
    this.#columns = this.querySelector('[data-read-more-columns]');

    if (!this.#button || !this.#columns) return;

    this.#button.addEventListener('click', this.#toggle);
    this.#updateButtonVisibility();

    window.addEventListener('resize', this.#updateButtonVisibility, { passive: true });
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#toggle);
    window.removeEventListener('resize', this.#updateButtonVisibility);
  }

  #updateButtonVisibility = () => {
    if (!this.#button || !this.#columns) return;

    if (this.dataset.expanded === 'true') {
      this.#button.hidden = false;
      return;
    }

    const needsToggle = this.#columns.scrollHeight > this.#columns.clientHeight + 2;
    this.#button.hidden = !needsToggle;
  };

  /**
   * @param {Event} event
   */
  #toggle = (event) => {
    event.preventDefault();

    const expanded = this.dataset.expanded === 'true';
    this.dataset.expanded = expanded ? 'false' : 'true';
    this.#button?.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    if (expanded) {
      requestAnimationFrame(this.#updateButtonVisibility);
    }
  };
}

if (!customElements.get('product-details-read-more')) {
  customElements.define('product-details-read-more', ProductDetailsReadMore);
}
